<template>
  <div class="pos-relative">
    <Modal
      @close="setCloseModal"
      :show="showModal"
      :show_modal_sidebar="showImportSubjects">
      <h1 slot="header"><span
        v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1">{{ $t('vue2.createklass.create_klasses') }}</span><span
        v-else>{{ $t('vue2.createklass.import_subject_to_the_klass') }}</span></h1>
      <div slot="body">
        <div class="tabs">
          <div class="title" v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1">
            <h3 class="flex align-center">{{ $t('vue2.createklass.schoolyear') }}
              <ChangeSchoolYear :whiteTheme="true" style="margin-left: 10px"></ChangeSchoolYear>
            </h3>
          </div>
        </div>
        <a v-if="activeSchoolYears.length > 1 && alreadyCreatedKlassesToImportSubjectTo.length < 1"
           :href="copySubjectsSchoolYearUrl">
          >> {{ $t('vue2.year_transfer.year_transfer_link') }}
        </a>
        <div class="content pos-relative">
          <div class="flex modal-form__titles">
            <h3 class="flex-1"><span v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1">{{
                $t('vue2.createklass.klass_name')
              }}</span><span v-else>Klasser uden fag</span></h3>
            <h3 class="flex-2" v-if="showImportSubjects">{{ $t('vue2.createklass.klass_step') }}</h3>
          </div>
          <div class="modal-form-group"
               v-for="(klass, key) in klasses"
               :class="[{'bgDelete': klass.deleteClass}, {'modal-form-group__already_created_klass': alreadyCreatedKlassesToImportSubjectTo.length > 0}, {'modal-form-group--first': key === 0}]">
            <div class="flex create-form">
              <div class="flex-1" v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1">
                <input type="text"
                       :ref="klass"
                       :class="[{'missing-input': !klass.isValid}, {'missing-input': klass.isSameName}]"
                       placeholder="1.a"
                       @input="checkAllForText(klass, key, $event.target.value)"
                       class="namefield"/>
              </div>
              <div class="flex-1 create-form__name" v-else>
                {{ klass.name }}
              </div>
              <div class="import-klass flex-2" v-if="showImportSubjects">
                <div v-for="(klassStep, key) in stepNumbers"
                     class="import-klass__step"
                     @click="setKlassImport(klass, klassStep, $event)"
                     @mouseenter="mouseOverStep(klassStep, $event, klass)"
                     :class="[
                      {'lastStep': key === (stepNumbers.length - 1)},
                      {'firstStep': key === 0},
                      {'isActive': klass.template === klassStep}
                    ]">
                  <div class="import-klass__step__inner">{{ klassStep }}</div>
                </div>
              </div>
            </div>
            <div class="delete__user"
                 v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1"
                 @click="removeKlass(klass)"
                 @mouseenter="addDeleteClass(klass)"
                 @mouseleave="removeDeleteClass(klass)">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <div>
            <div class="add-more-button" @click="pushNewKlass" v-if="alreadyCreatedKlassesToImportSubjectTo.length < 1">
            <span class="plus--icon">
              +
            </span>
              <span class="add-more-button__text"> {{ $t('vue2.createusers.add_more') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex flex-end pad-10">
        <p v-if="someWithSameName" class="error-message marg-20-right warning-text">{{
            $t('vue2.createklass.warning_text')
          }}</p>
        <!-- Inactive button -->
        <button v-if="showInactiveButton"
                class="submit-btn--disabled">
          {{ $t('vue2.createusers.create') }}
        </button>
        <button class="submit-button" v-if="!showInactiveButton && !isAwaitingServerResponse"
                @click="submitOrSetDuration">
          {{ buttonText }}
        </button>
        <button class="submit-button submit-button--loading"
                v-if="!showInactiveButton && isAwaitingServerResponse"></button>
        <StandardDurationSetting
          :isOpenModal="isOpenDurationModal"
          @close="isOpenDurationModal = false"
          @submit="saveDuration">
        </StandardDurationSetting>
      </div>
      <div slot="sidebar" class="width-100">
        <div class="explainer-text align-center pad-20" v-if="!klassStepIsSelected">
          <div class="marg-10-right">
            <span class="icon-ask icon-question3"></span>
          </div>
          <p class="bold">{{ $t('vue2.createklass.import_subjects_question') }}</p>
        </div>
        <div class="explainer-text align-center pad-20" v-else>
          <div class="marg-10-right">
            <span class="step-is-choosen icon-checkmark-circle"></span>
          </div>
          <p class="bold">{{ $t('vue2.createklass.import_subjects_done') }}</p>
        </div>
        <ShowSubjects
          :arrowPosition="subjectsArrowPosition"
          :activeKlassStep="activeKlassStep"
          :klassStepIsSelected="klassStepIsSelected"
          :country="country">
        </ShowSubjects>
        <div :style="{top: subjectsArrowPosition + 5 + 'px'}" class="small-arrow"></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import ShowSubjects from './CreateKlassesSubjectList'
import ChangeSchoolYear from '../../School/ChangeSchoolYear'
import StandardDurationSetting from '../../School/StandardDurationSetting'

export default {
  components: {StandardDurationSetting, Modal, ShowSubjects, ChangeSchoolYear},
  data () {
    return {
      showModal: false,
      klasses: [],
      showSubjects: false,
      subjectsArrowPosition: 100,
      activeKlassStep: 1,
      klassStepIsSelected: false,
      someWithSameName: false,
      schoolCountry: 'dk',
      isOpenDurationModal: false,
      isAwaitingServerResponse: false,
      debounceTimer: null
    }
  },
  computed: {
    showImportSubjects () {
      return this.schoolCountry === 'dk' || this.schoolCountry === 'no'
    },
    showInactiveButton () {
      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
        if (this.klassesToSubmit.length < 1) {
          return true
        }
      } else {
        if (this.subjectsToCreateWhenAlreadyCreatedKlasses.length < 1) {
          return true
        }
      }
    },
    openFromOtherComponent () {
      return eventbus.createKlassModal
    },
    alreadyCreatedKlassesToImportSubjectTo () {
      return eventbus.theKlassesToImportSubjectTo
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    activeSchoolYears () {
      return this.schoolYears.filter(year => year.active)
    },
    selectedSchoolYear () {
      return this.activeSchoolYear.name
    },
    country () {
      return window.SCHOOL.country
    },
    stepNumbers () {
      return this.country === 'NO' ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : [1, 2, 3, 4, 5, 6, 7, 8, 9]
    },
    subjectsToCreateWhenAlreadyCreatedKlasses () {
      return this.klasses.filter(klass => klass.template).map(cal => {
        let klassObj = {
          calendar_id: cal.calendarId,
          step: cal.template
        }
        return klassObj
      })
    },
    klassesToSubmit () {
      let klassesToSubmit = []
      for (let i = 0; i < this.klasses.length; i++) {
        if (this.klasses[i].name.length > 0) {
          klassesToSubmit.push(
            {
              'name': this.klasses[i].name,
              'type': 'class',
              'year': this.selectedSchoolYear,
              'template': this.klasses[i].template.toString()
            })
        }
      }
      return klassesToSubmit
    },
    buttonText () {
      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
        if (this.klassesToSubmit.length < 1) {
          return this.$t('vue2.createusers.create')
        } else {
          let klassesPluralized = this.klassesToSubmit.length === 1 ? this.$t('vue2.createklass.klass') : this.$t('vue2.createklass.klasses')
          return this.$t('vue2.createusers.create') + ' ' + this.klassesToSubmit.length + ' ' + klassesPluralized
        }
      } else {
        return this.subjectsToCreateWhenAlreadyCreatedKlasses.length === 1 ? this.$t('vue2.createusers.create') : this.$t('vue2.createusers.create') + ' ' + this.$t('vue2.common.in') + ' ' + this.subjectsToCreateWhenAlreadyCreatedKlasses.length + ' ' + this.$t('vue2.createklass.klasses')
      }
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    copySubjectsSchoolYearUrl () {
      if (this.activeSchoolYears.length < 2) {
        return '#'
      }
      let sortedSchoolYears = this.activeSchoolYears.sort(function (a, b) {
        return new Date(b.student_time_start) - new Date(a.student_time_start)
      })
      return '/schools/' + this.activeSchool.id + '/year_transfer/new?from_school_year_id=' + sortedSchoolYears[1].id + '&to_school_year_id=' + sortedSchoolYears[0].id
    },
    isCourseImportSelected () {
      let isSelected = false
      this.klasses.forEach(klass => {
        if (klass.template) {
          isSelected = true
        }
      })
      return isSelected
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    user () {
      return this.$store.state.user
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    isUserCanEditSchool () {
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf('can_manage_school') > -1 || this.user.admin
      } else {
        return true
      }
    }
  },
  watch: {
    openFromOtherComponent () {
      if (this.openFromOtherComponent) {
        this.setShowModal()
      }
    }
  },
  methods: {
    submitOrSetDuration () {
      if (this.isCourseImportSelected && this.isUserCanEditSchool) {
        this.isOpenDurationModal = true
      } else {
        this.submitKlasses()
      }
    },
    saveDuration () {
      this.submitKlasses()
    },
    setIsSameInputToFalse () {
      if (!this.someWithSameName) {
        return
      } else {
        this.someWithSameName = false
        this.klasses.forEach(obj => {
          obj.isSameName = false
        })
      }
    },
    setSameInputOnKlass (klassName) {
      for (let i = 0; i < this.klasses.length; i++) {
        if (this.klasses[i].name !== '') {
          if (this.klasses[i].name === klassName) {
            this.klasses[i].isSameName = true
          }
        }
      }
    },
    checkForSameNameInKlasses () {
      let nbr = 0
      for (let i = 0; i < this.klassesToSubmit.length; i++) {
        for (let j = 0; j < this.klassesToSubmit.length; j++) {
          if (j !== i) {
            if (this.klassesToSubmit[i].name === this.klassesToSubmit[j].name) {
              this.setSameInputOnKlass(this.klassesToSubmit[i].name)
              nbr++
            }
          }
        }
      }
      if (nbr > 0) {
        this.someWithSameName = true
      } else {
        this.someWithSameName = false
      }
    },
    mouseOverStep (klassStep, event, klass) {
      if (klass.template !== '') {
        this.activeKlassStep = klass.template
        this.klassStepIsSelected = true
      } else {
        this.activeKlassStep = klassStep
        this.klassStepIsSelected = false
      }
      this.showSubjects = true
      let modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top
      let targetPxFromTop = event.target.getBoundingClientRect().top
      this.subjectsArrowPosition = targetPxFromTop - modalPxFromTop
    },
    checkAllForText (klass, idx, text) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.klasses[idx]['name'] = text
        this.setIsSameInputToFalse()
        this.isTemplateButNotName(klass)
        let klassesWithName = []
        for (let i = 0; i < this.klasses.length; i++) {
          if (this.klasses[i].name.length > 0) {
            klassesWithName.push(this.klasses[i])
          }
        }
        if (klassesWithName.length === this.klasses.length) {
          this.pushNewKlass()
        }
        this.checkForSameNameInKlasses(klass)
      }, 250)
    },
    addDeleteClass (klass) {
      this.klasses[this.klasses.indexOf(klass)].deleteClass = true
    },
    removeDeleteClass (klass) {
      this.klasses[this.klasses.indexOf(klass)].deleteClass = false
    },
    setShowModal () {
      this.klassStepIsSelected = false
      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
        this.pushNewKlass()
        this.pushNewKlass()
        this.pushNewKlass()
        setTimeout(() => {
          document.querySelector('.namefield').focus()
        }, 100)
      } else {
        this.alreadyCreatedKlassesToImportSubjectTo.forEach(klass => {
          this.pushExistingKlass(klass)
        })
      }
      this.showModal = true
      window.setTimeout(_ => {
        if (document.querySelector('.import-klass') && document.querySelector('.modal-container')) {
          const modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top
          const targetPxFromTop = document.querySelector('.import-klass').getBoundingClientRect().top
          this.subjectsArrowPosition = targetPxFromTop - modalPxFromTop
        }
      }, 300)
    },
    pushNewKlass () {
      this.klasses.push({
        name: '',
        schoolYear: '',
        template: '',
        deleteClass: false,
        isValid: true,
        isSameName: false
      })
      if (this.klasses.length > 4) {
        setTimeout(() => {
          this.scrollInDiv()
        }, 0)
      }
    },
    pushExistingKlass (klass) {
      this.klasses.push({
        calendarId: klass.id,
        schoolId: klass.school_id,
        name: klass.name,
        template: '',
        deleteClass: false,
        isValid: true,
        isSameName: false
      })
    },
    isTemplateButNotName (klass) {
      const idx = this.klasses.indexOf(klass)
      if (this.klasses[idx].template.length < 1) {
        this.klasses[idx].isValid = true
      } else {
        this.klasses[idx].isValid = this.klasses[idx].name.length > 0
      }
    },
    removeKlass (klass) {
      this.klasses.splice(this.klasses.indexOf(klass), 1)
      this.setIsSameInputToFalse()
      this.checkForSameNameInKlasses()
    },
    setKlassImport (klass, value, event) {
      const idx = this.klasses.indexOf(klass)
      if (this.klasses[idx].template === value) {
        this.klasses[idx].template = ''
        this.klassStepIsSelected = false
        this.isTemplateButNotName(klass)
      } else {
        this.klasses[idx].template = value
        this.klassStepIsSelected = true
        this.activeKlassStep = klass.template
        // If no text then focus on the inputfield
        if (this.klasses[idx].name.length < 1) {
          document.querySelectorAll('.namefield')[idx].focus()
        }
        this.isTemplateButNotName(klass)
      }
    },
    setCloseModal () {
      this.showModal = false
      eventbus.createKlassModal = false
      this.klasses = []
      eventbus.theKlassesToImportSubjectTo = []
      this.isAwaitingServerResponse = false
    },
    scrollInDiv () {
      var objDiv = document.querySelector('.modal-body')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    submitKlasses () {
      if (this.alreadyCreatedKlassesToImportSubjectTo.length === 0) {
        this.checkForSameNameInKlasses()
        if (!this.someWithSameName) {
          docendo.schoolBulkCreateCalendars(
            this.activeSchool.id,
            this.activeSchoolYear.id,
            this.klassesToSubmit,
            success => {
              eventbus.toast = {text: this.$t('vue2.createklass.succes_text'), 'success': true}
              this.$store.dispatch('getSchoolCalendars', this.activeSchool.id)
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_klass': true})
              if (window.Intercom) {
                window.Intercom('trackEvent', 'Created Classes')
              }
              const newSubjectsCreated = new window.CustomEvent('new_subjects_created', {
                bubbles: true,
                cancelable: true
              })
              window.document.dispatchEvent(newSubjectsCreated)
              // activate onboardArrow again
              setTimeout(() => {
                this.$store.commit('setOnboardingStep', 0)
              }, 2500)
            },
            errors => {
              eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
            }
          )
          this.setCloseModal()
        }
      } else {
        this.isAwaitingServerResponse = true
        docendo.calendarCreateNormSubjects(this.klasses[0].schoolId, this.subjectsToCreateWhenAlreadyCreatedKlasses, success => {
          eventbus.toast = {text: this.$t('vue2.createklass.subjects_created_successfully'), 'success': true}
          this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
          this.updateSubjectsIfInRORCalendar()
          this.setCloseModal()
        }, failure => {
          eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
          this.setCloseModal()
        })
      }
    },
    updateSubjectsIfInRORCalendar () {
      const updateSidebarInROR = new window.CustomEvent('vueUpdateSidebarSubjects', {bubbles: true, cancelable: true})
      window.document.dispatchEvent(updateSidebarInROR)
    }
  },
  beforeMount () {
    this.schoolCountry = window.SCHOOL.country.toLowerCase()
  }
}

</script>

<style scoped>
@import '../../../assets/css/variables.css';

.content {
  border: 1px solid #cccccc;
  padding-top: 20px;
  background: white;
  margin-top: 10px;
}

.modal-form-group {
  display: flex;
  align-items: center;
  padding: 10px 20px;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #999
}

.modal-form__titles {
  padding: 0 20px;
}

.modal-form__titles > h3 {
  font-size: 1rem;
}

.modal-form__titles > h3:nth-child(2) {
  padding-right: 20px;
  margin-left: 5px;
}

.flex-1 {
  flex: 1;
}

.create-form {
  width: 98%;
}

.modal-form-group > .delete__user {
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;
}

.modal-form-group > .delete__user:hover {
  background-color: #ffdcdc;
  border: 1px solid #d72b3f;
  color: #d72b3f;
}

.bgDelete {
  background-color: #ffdcdc !important;
}

.create-form:first-child {
  margin-top: 0;
}

.create-form:last-child {
  border-bottom: 0 !important;
}

.create-form > div {
  flex: 1;
}

.create-form > div.flex-2 {
  flex: 2;
}

.create-form > div:first-child,
.flex-1:first-child {
  margin-right: 5px;
}

.create-form__name {
  margin-right: 0 !important;
}

.create-form > div:nth-child(2) {
  margin-left: 5px;
  min-height: 34px;
}

.create-form > div label {
  font-size: 10px;
}

.flex-end {
  justify-content: flex-end;
}

.add-more-button {
  padding: 10px 30px;
  color: var(--blue);
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
}

.add-more-button:hover .add-more-button__text {
  text-decoration: underline;
}

.plus--icon {
  cursor: pointer;
  display: inline-flex;
  border: 2px solid var(--blue);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: space-around;
  font-weight: bold;
  font-size: 15px;
  padding-left: 1px;
  text-decoration: none !important;
}

.create-form__submit {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

.import-klass {
  display: flex;
}

.import-klass__step:first-child {
  border-left: 1px solid #acb6be;
}

.import-klass__step:first-child,
.import-klass__step.firstStep > .import-klass__step__inner {
  border-radius: 4px 0 0 4px;
}

.import-klass__step:last-child,
.import-klass__step.lastStep > .import-klass__step__inner {
  border-radius: 0 4px 4px 0;
}

.import-klass__step {
  flex: 1;
  justify-content: center;
  align-items: center;
  border: solid #acb6be;
  border-width: 1px 1px 1px 0;
  cursor: pointer;
}

.import-klass__step:hover {
  background-color: #acb6be;
  color: white;
}

.import-klass__step.isActive {
  background-color: var(--blue);
  color: white;
}

.import-klass__step > .import-klass__step__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  user-select: none;
}

.small-arrow {
  position: absolute;
  z-index: 1;
  transition: all 0.3s;
  border-bottom: 1px solid var(--dark-blue);
  border-left: 1px solid var(--dark-blue);
  right: 208px;
  width: 24px;
  height: 24px;
  background: white;
  transform: rotate(50grad);
  pointer-events: none;
}

.submit-btn--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

.tabs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.tabs h3 {
  margin-right: 10px;
}

.tabs > div > div {
  cursor: pointer;
  padding: 4px 16px;
  border: 1px solid #cccccc;
  font-size: 14px;
  color: #606773;
  font-weight: 700;
}

.tabs > div > div:first-child {
  border-radius: 4px 0 0 4px;
}

.tabs > div > div:nth-child(2) {
  border-radius: 0 4px 4px 0;
}

.tabs > div > div.active {
  background-color: var(--blue);
  border: none;
  color: white;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

.missing-input {
  border-color: red;
}

.warning-text {
  color: red;
}

.explainer-text {
  line-height: 1.1;
  display: flex;
}

.icon-ask {
  font-size: 20px;
}

.step-is-choosen {
  color: #3ecf8e;
  font-size: 20px;
}

a:hover {
  text-decoration: underline;
}

.create-form__name {
  display: flex;
  align-items: center;
}

.modal-form-group__already_created_klass {
  border: 1px solid #eeeeee;
  border-width: 0 0 1px 0;
}

.modal-form-group__already_created_klass.modal-form-group--first {
  margin-top: 1rem;
  border-width: 1px 0 1px 0;
}

</style>



// WEBPACK FOOTER //
// CreateKlasses.vue?14467166